import { lazy, Suspense } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Layout from "./components/layout/Layout";
import { usePageLocation } from "./hooks/useOverlay";
import CartPage from "./pages/CartPage";
import HomePage from "./pages/HomePage";
import ItemPage from "./pages/ItemPage";
import NotFoundPage from "./pages/NotFoundPage";
import SearchPage from "./pages/SearchPage";
import AdminAccess from "./components/admin/AdminAccess";
import { isOverlayPath } from "./routes";

const ReceiptWorkbench = lazy(() => import("./receipts/ReceiptWorkbench"));

// Browsing pages render in the layout; item / cart / search routes open on top of the page behind them.
export default function App() {
  const { pathname } = useLocation();
  const pageLocation = usePageLocation();

  if (pathname === "/receipts") return <Suspense fallback={<p>Loading receipt workspace…</p>}><ReceiptWorkbench /></Suspense>;

  return (
    <>
      <Layout>
        <Routes location={pageLocation}>
          <Route path="/" element={<HomePage />} />
          <Route path="/shop/:department/:subcategory?" element={<HomePage />} />
          <Route path="/latest" element={<HomePage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/Skraely" element={<AdminAccess />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Layout>
      {isOverlayPath(pathname) && (
        <Routes>
          <Route path="/item/:id" element={<ItemPage />} />
          <Route path="/search" element={<SearchPage />} />
        </Routes>
      )}
    </>
  );
}
